module.exports = __webpack_public_path__ + "img/zw.295464d2.svg";